import React from 'react';

interface PathologyTableButtonProps {
  onClick: () => void;
}
const PathologyTableButton = ({ onClick }: PathologyTableButtonProps) => {
  return (
    <button
      style={{
        marginLeft: '54px',
        textDecoration: 'underline',
        paddingBottom: '15px',
      }}
      className="hide-in-pdf"
      onClick={onClick}
    >
      See pathology results
    </button>
  );
};

export default PathologyTableButton;
